import { ThemeBase } from "../ThemeBase";
import innogyChargeLogoTemplate from "./template/innogy-charge-logo-template";
import styleSheet from "./styles/innogy-charge-theme.css?inline";

/**
 * innogy Charge
 * ---
 * White label brand. The `innogy` typeface ships with the theme (assets/font) and is declared
 * with @font-face inside the stylesheet, so there is nothing external to fetch.
 *
 * The innogy language pack is not part of the theme - it renames the product rather than
 * restyling it, and stays on InnogyChargeEnv.
 */
export class InnogyChargeTheme extends ThemeBase {
	static themeID = "innogy-charge";

	/**
	 * @override
	 */
	get primaryColor() {
		return "#c72185";
	}

	/**
	 * @override
	 */
	get backgroundColor() {
		return "#f9f9f9";
	}

	/**
	 * @override
	 */
	get styleSheet() {
		return styleSheet;
	}

	/**
	 * @override
	 */
	get logoForMenu() {
		return this.getLogo(`height="120"`);
	}

	/**
	 * @override
	 */
	get logoForLoader() {
		return this.getLogo();
	}

	/**
	 * @override
	 */
	get chargingAnimationUrl() {
		return "/themes/innogy-charge/assets/images/active.svg";
	}

	/**
	 * @override
	 */
	getLogo(attributes = '') {
		return innogyChargeLogoTemplate(attributes);
	}
}

new InnogyChargeTheme();
